import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useUpdatePrompt } from "../hooks/useUpdatePrompt";
import { memo } from "react";

export const UpdatePrompt = memo(() => {
  const { t } = useTranslation();

  const { showUpdatePrompt, onUpdate } = useUpdatePrompt();

  if (!showUpdatePrompt) {
    return null;
  }

  return (
    <Alert className="mb-2">
      <AlertTitle>{t("updatePrompt.title")}</AlertTitle>
      <AlertDescription className="flex flex-col gap-2 sm:flex-row sm:justify-between items-start sm:items-center">
        <span>{t("updatePrompt.description")}</span>
        <Button onClick={onUpdate} className="mt-2 sm:mt-0">
          {t("updatePrompt.button")}
        </Button>
      </AlertDescription>
    </Alert>
  );
});
